import styled from "styled-components";

const BlinkingCursor = () => {
  return (
    <Wrapper>
      <Cursor />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Cursor = styled.span`
  display: inline-block;
  width: 8px;
  height: 24px;
  background-color: #6b7280;
  animation: blink 1s infinite;

  @keyframes blink {
    0%,
    49% {
      opacity: 1;
    }
    50%,
    100% {
      opacity: 0;
    }
  }
`;

export default BlinkingCursor;
